import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HiringReferralsListPage from './pages/HiringReferralsListPage';
import HiringReferralsDetailPage from './pages/HiringReferralsDetailPage';
import HiringDirectionsListPage from './pages/HiringDirectionsListPage';
import HiringDirectionsDetailPage from './pages/HiringDirectionsDetailPage';

const HiringModule: React.FC = () => {
  return (
    <Routes>
      <Route path="/referrals" element={<HiringReferralsListPage />} />
      <Route path="/referrals/:applicationId" element={<HiringReferralsDetailPage />} />
      <Route path="/directions" element={<HiringDirectionsListPage />} />
      <Route path="/directions/:directionId" element={<HiringDirectionsDetailPage />} />
      <Route path="/" element={<Navigate to="/hiring/referrals" replace />} />
      <Route path="*" element={<Navigate to="/hiring/referrals" replace />} />
    </Routes>
  );
};

export default HiringModule;
